class LookUpRequest{
    constructor(){
        this.countrycode = "";
        this.state_code="";
        this.religion_id="";
        this.mobile_number="";
         this.email_Id="";
         this.district="";
    }
    }

export default LookUpRequest;